import React, { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, LabelList } from "recharts";
import api from "@/lib/api";
import { fmtCurrency } from "@/utils/format";

const RANGES = { "Ç1": "Ocak–Mart", "Ç2": "Nisan–Haziran", "Ç3": "Temmuz–Eylül", "Ç4": "Ekim–Aralık" };
const short = (v) => (v >= 1e6 ? `${(v / 1e6).toFixed(1)}M` : v >= 1e3 ? `${Math.round(v / 1e3)}K` : v ? String(Math.round(v)) : "");

export const QuarterlySalesChart = () => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [data, setData] = useState({ quarters: [], years: [] });

  useEffect(() => {
    api.get(`/reports/quarterly?year=${year}&_ts=${Date.now()}`).then(({ data: d }) => setData(d)).catch(() => {});
  }, [year]);

  const total = data.quarters.reduce((s, q) => s + q.subtotal, 0);

  return (
    <div className="mt-6 pt-5 border-t-2 border-dashed border-neutral-300" data-testid="quarterly-sales-chart">
      <div className="flex items-center justify-between gap-3 mb-3">
        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-neutral-500">Çeyrek Bazlı · KDV Hariç</div>
          <div className="text-sm font-bold tracking-tight">
            {year} Toplam: <span className="font-mono" data-testid="quarterly-year-total">{fmtCurrency(total)}</span>
          </div>
        </div>
        <select value={year} onChange={(e) => setYear(Number(e.target.value))}
          className="border-2 border-[#09090B] bg-white px-2 py-1 text-xs font-mono rounded-none" data-testid="quarterly-year-select">
          {(data.years.length ? data.years : [year]).map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="h-[200px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data.quarters} margin={{ top: 18, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid stroke="#D4D4D8" vertical={false} />
            <XAxis dataKey="quarter" stroke="#09090B" fontSize={11} tickLine={false} axisLine={{ stroke: "#09090B" }}
              tickFormatter={(q) => `${q} (${RANGES[q]?.split("–").map((m) => m.slice(0, 3)).join("–")})`} />
            <YAxis stroke="#09090B" fontSize={10} tickLine={false} axisLine={{ stroke: "#09090B" }} tickFormatter={short} />
            <Tooltip
              contentStyle={{ background: "#fff", border: "2px solid #09090B", borderRadius: 0, fontFamily: "monospace" }}
              formatter={(v, _k, item) => [`${fmtCurrency(v)} · ${item.payload.count} sipariş`, "KDV Hariç Ciro"]}
              labelFormatter={(q) => `${q} · ${RANGES[q] || ""} ${year}`}
            />
            <Bar dataKey="subtotal" fill="#09090B">
              <LabelList dataKey="subtotal" position="top" fontSize={10} fontFamily="monospace" formatter={short} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
